var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheILP',{attrs:{"ilpPortfolios":_vm.ilpPortfolios,"rcmdIlpProducts":_vm.rcmdIlpProducts,"client2Included":_vm.kycForm.hasClient2,"ilpFundList":_vm.ilpFundList,"limitation":{portfolio: 3, funds: 8}},on:{"save":_vm.saveIlp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }